export default "__VITE_ASSET__BtnqIdsc__"